module.exports = __webpack_public_path__ + "static/media/img-cover-01.c73c5713.png";